
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("lORz6"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("lORz6", function(module, exports) {

let $fe27d16e964fc5be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe27d16e964fc5be$var$load("h3ABO"),
    $fe27d16e964fc5be$var$load("l0dTs"),
    $fe27d16e964fc5be$var$load("9hYRW"),
    $fe27d16e964fc5be$var$load("kpm7S"),
    $fe27d16e964fc5be$var$load("gwky3"),
    $fe27d16e964fc5be$var$load("cWN1a"),
    $fe27d16e964fc5be$var$load("2YffH"),
    $fe27d16e964fc5be$var$load("g7ggm"),
    $fe27d16e964fc5be$var$load("6mHrv"),
    $fe27d16e964fc5be$var$load("awWN9"),
    $fe27d16e964fc5be$var$load("cM9WO"),
    $fe27d16e964fc5be$var$load("3wNgF"),
    $fe27d16e964fc5be$var$load("8tyVc"),
    $fe27d16e964fc5be$var$load("hZtKG"),
    $fe27d16e964fc5be$var$load("dkqvW"),
    $fe27d16e964fc5be$var$load("lVO3w"),
    $fe27d16e964fc5be$var$load("hyzoX"),
    $fe27d16e964fc5be$var$load("cmqxT"),
    $fe27d16e964fc5be$var$load("h9Ed7"),
    $fe27d16e964fc5be$var$load("eBRUf"),
    $fe27d16e964fc5be$var$load("ggdmt"),
    $fe27d16e964fc5be$var$load("kbRvk"),
    $fe27d16e964fc5be$var$load("7gHIc"),
    $fe27d16e964fc5be$var$load("3sb7M"),
    $fe27d16e964fc5be$var$load("k3jER"),
    $fe27d16e964fc5be$var$load("9wzNh"),
    $fe27d16e964fc5be$var$load("8YSo7"),
    $fe27d16e964fc5be$var$load("5ii2L"),
    $fe27d16e964fc5be$var$load("5Uvxw"),
    $fe27d16e964fc5be$var$load("9ldRJ"),
    $fe27d16e964fc5be$var$load("50ame"),
    $fe27d16e964fc5be$var$load("7do1E"),
    $fe27d16e964fc5be$var$load("77dkW"),
    $fe27d16e964fc5be$var$load("1MlIV"),
    $fe27d16e964fc5be$var$load("9ijrN"),
    $fe27d16e964fc5be$var$load("6iz6l"),
    $fe27d16e964fc5be$var$load("4SCW2"),
    $fe27d16e964fc5be$var$load("jYV57"),
    $fe27d16e964fc5be$var$load("76qVV"),
    $fe27d16e964fc5be$var$load("hv4mn"),
    $fe27d16e964fc5be$var$load("Wowvf"),
    $fe27d16e964fc5be$var$load("dYtBN"),
    $fe27d16e964fc5be$var$load("6wr18"),
    $fe27d16e964fc5be$var$load("kjZZD"),
    $fe27d16e964fc5be$var$load("55Z9F"),
    $fe27d16e964fc5be$var$load("4vp3Q"),
    $fe27d16e964fc5be$var$load("lIuUE"),
    $fe27d16e964fc5be$var$load("37ldp"),
    $fe27d16e964fc5be$var$load("ffEVr"),
    $fe27d16e964fc5be$var$load("9AXkC"),
    $fe27d16e964fc5be$var$load("28arV"),
    $fe27d16e964fc5be$var$load("hhss7"),
    $fe27d16e964fc5be$var$load("fiBiE"),
    $fe27d16e964fc5be$var$load("lBssV"),
    $fe27d16e964fc5be$var$load("dP7ao"),
    $fe27d16e964fc5be$var$load("hogcU"),
    $fe27d16e964fc5be$var$load("8QOYK"),
    $fe27d16e964fc5be$var$load("f1meW"),
    $fe27d16e964fc5be$var$load("7EorR"),
    $fe27d16e964fc5be$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.82e099f1.js.map
